import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

const LinkButton = ({
  label,
  onClick,
  href,
  variant,
  className,
  blank,
  icon,
}) => {
  return (
    <>
      {blank ? (
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={href}
          onClick={onClick}
          className={clsx(className, variant, "button", icon && "icon-link")}
        >
          {icon && (
            <span
              style={{
                marginRight: 8,
                position: "relative",
                top: 4,
              }}
            >
              {icon}
            </span>
          )}{" "}
          {label}
        </a>
      ) : (
        <Link
          to={href}
          onClick={onClick}
          className={clsx(className, variant, "button")}
        >
          {label}
        </Link>
      )}
    </>
  );
};

export default LinkButton;
